import memoize from 'lru-memoize';
import { createValidator, required, email } from 'utils/validation';

const loginValidation = createValidator({
  username: [email, required],
  password: [required]
});

export default memoize(10)(loginValidation);
